export default __webpack_public_path__ + "static/media/hyuga_neji.96cf76b8.png";